import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

import { ContextService } from 'src/core/services/context.service';
import { IsDefined } from 'class-validator';

export class UserTaskDataService extends DataService<typeof Model.Rules.Logic.ViewModels.UserTaskItem, Model.Rules.Logic.ViewModels.UserTaskItem, UserTaskItem> {
	protected map(entity: Model.Rules.Logic.ViewModels.UserTaskItem): UserTaskItem {
		return new UserTaskModel(entity);
	}

	static make(context?: ContextService): UserTaskDataService {
		return new UserTaskDataService(context, ctx => ctx.UserTasks);
	}

	private id = -1;

	add(modelName: string, modelId: string, daedline?: Date, assignedToId?: number, priority?: number, title?:string): Promise<UserTaskItem> {
		const entity = new Model.Rules.Logic.ViewModels.UserTaskItem();
		if (daedline != null) {
			daedline.setHours(23, 59);
			entity.daedline = daedline;
		}
		entity.id = this.id--;
		entity.assignedToId = assignedToId;
		entity.daedline = daedline;
		entity.priority = priority;
		entity.title = title;
		(<any>entity).dynamicProperties = {};
		entity.state = 0;
		entity.modelType = modelName;
		entity.modelId = modelId;
		return this.create(() => entity);
	}
}

export class UserTaskModel extends EntityModel<Model.Rules.Logic.ViewModels.UserTaskItem, UserTaskItem> implements UserTaskItem {
	@property<UserTaskModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<UserTaskModel>(o => o.entity.title, (o, value) => o.entity.title = value)
	@IsDefined({
		message: "The user task title must not be empty"
	})
	public title: string;

	@property<UserTaskModel>(o => o.entity.body, (o, value) => o.entity.body = value)
	public body: string;

	@property<UserTaskModel>(o => o.entity.changeReason, (o, value) => o.entity.changeReason = value)
	public changeReason: string;

	@property<UserTaskModel>(o => o.entity.daedline, (o, value) => o.entity.daedline = value)
	@IsDefined({
		message: "The user tasks deadline must not be empty"
	})
	public deadline: Date;

	@property<UserTaskModel>(o => o.entity.assignedToId, (o, value) => o.entity.assignedToId = value)
	@IsDefined({
		message: "The user task must have a target user"
	})
	public assignedToId: number;

	@property<UserTaskModel>(o => o.entity.state, (o, value) => o.entity.state = value)
	public status: number;

	@property<UserTaskModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	public priority: number;

}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/form/user-task.data.ts